import { createAsyncThunk } from '@reduxjs/toolkit';

import { ensureFetchDelay } from '../../helpers/fetch';
import svpApiClient from '../../services/svpApiClient';
import { parseParamsFromUrl } from '../../services/svp/apiClient';

import type { SvpCategoryAdditional } from '@vgtv/api-client/lib/svp_category';
import type { GetCategoriesArgs } from '../../services/svp/apiClient';
import type { Vendor } from '../../types';

const fetchSvpCategories = createAsyncThunk(
  'categories/fetchSvpCategories',
  ({ dataUrl, vendor }: { dataUrl: string; vendor: Vendor }) => {
    return ensureFetchDelay(
      svpApiClient.getCategories<SvpCategoryAdditional>({
        ...parseParamsFromUrl<GetCategoriesArgs>(dataUrl),
        vendor,
      })
    );
  }
);

const fetchAllCategories = createAsyncThunk(
  'categories/fetchAllCategories',
  (vendor: Vendor) =>
    ensureFetchDelay(
      svpApiClient.getCategories<SvpCategoryAdditional>({
        additional: true,
        vendor,
      })
    )
);

export { fetchSvpCategories, fetchAllCategories };
